<template>
    <div class="drag-root">
        <div v-for="(item, index) in lang" :key="index">
            <div class="drag-list" :style="{ width: width + 'px', height: width + 'px' }">
                <div class="drag-list-wrap">
                    <div
                        :id="'dragtarget-' + i"
                        class="dragtarget"
                        :key="i"
                        v-for="(imgData, i) in originPositions"
                        :style="{ left: imgData.left + 'px', top: imgData.top + 'px', width: imgWidthList[i] + 'px' }"
                    >
                        <img
                            :src="require(`@/assets/images/${i}.png`)"
                            :style="{ width: imgWidthList[i] + 'px' }"
                            :class="{ 'dragtarget-img-hide': !positions[i].filled }"
                        />
                    </div>
                </div>
            </div>

            <div style="padding: 0 4.6875rem" v-show="!isShare">
                <div class="cur-drag-container" :style="{ 'min-height': 400 * scale + 'px' }">
                    <div
                        :id="'drag-' + i"
                        v-touch:start="onTouchStart"
                        v-touch:moving="onTouchMove"
                        v-touch:end="onTouchEnd"
                        class="cur-drag-box"
                        :key="i"
                        v-for="(val, i) in positions"
                        :style="{ left: val.left + 'px', top: val.top + 'px', transform: `rotate(${val.rotate}deg)` }"
                    >
                        <img
                            v-if="!positions[i].filled"
                            :src="require(`@/assets/images/${i}.png`)"
                            :style="{ width: imgWidthList[i] + 'px' }"
                        />
                    </div>
                </div>
            </div>

            <!-- 三个分享 -->
            <div class="shareWrap" v-show="isShare">
                <div class="share" @click="handleShare('facebook')">
                    <span><img src="@/assets/images/butten_icon_share.png" alt="" /></span>
                    <div>{{ item[9] }}</div>
                </div>
                <p></p>
                <div class="share" @click="handleShare('twitter')">
                    <span><img src="@/assets/images/butten_icon_share.png" alt="" /></span>
                    <div>{{ item[10] }}</div>
                </div>
                <p></p>
                <div class="share" @click="handleShare">
                    <span><img src="@/assets/images/butten_icon_share.png" alt="" /></span>
                    <div>{{ item[8] }}</div>
                </div>
                <input type="text" v-model="urlShare" style="opacity: 0" id="input" />
            </div>
        </div>
        <div class="tooltip" v-show="infoShow">
            <div class="tooltiptext">{{ tooltipMsg }}</div>
        </div>
    </div>
</template>

<script>
import { lang } from '@/tool/archeroLang'
import $ from 'jquery'

window.$ = $

export default {
    props: ['puzzle', 'action', 'isShare', 'language', 'shareUUID'],
    data() {
        let positions = [
            {
                left: 120,
                top: 100,
                filled: false,
                rotate: 45
            },
            {
                left: 142,
                top: 45,
                filled: false,
                rotate: 23
            },
            {
                left: 11,
                top: 0,
                filled: false
            },
            {
                left: 182,
                top: 70,
                filled: false,
                rotate: 79
            },
            {
                left: 170,
                top: 30,
                filled: false
            },
            {
                left: 80,
                top: 10,
                filled: false,
                rotate: 30
            },
            {
                left: 120,
                top: 10,
                filled: false
            },
            {
                left: 210,
                top: 30,
                filled: false,
                rotate: 232
            },
            {
                left: 190,
                top: 44,
                filled: false
            },
            {
                left: 91,
                top: 70,
                filled: false,
                rotate: 123
            },
            {
                left: 26,
                top: 61,
                filled: false
            },
            {
                left: 134,
                top: 60,
                filled: false
            },
            {
                left: 180,
                top: 80,
                filled: false,
                rotate: 80
            },
            {
                left: 210,
                top: 20,
                filled: false,
                rotate: -42
            },
            {
                left: 240,
                top: 88,
                filled: false,
                rotate: -80
            },
            {
                left: 1,
                top: 93,
                filled: false,
                rotate: 45
            }
        ]
        positions.forEach(a => {
            a.rotate = a.rotate || 0
        })

        return {
            positions,
            fillIndex: -1,
            minDt: Number.MAX_VALUE,
            width: 930,
            originWidth: 930,
            originPositions: [],
            imgWidthList: [267, 212, 335, 208, 207, 333, 221, 275, 276, 212, 349, 208, 207, 331, 212, 272],
            scale: 1,
            curDragIndex: -1,
            dragDisable: false,
            lang: [{}],
            urlShare: '',
            infoShow: false,
            tooltipMsg: ''
        }
    },
    created() {
        this.init()
    },
    mounted() {
        this.initPosition()
        for (let i in lang) {
            this.lang[0][i] = lang[i][this.language]
        }
    },
    methods: {
        initPosition() {
            setTimeout(() => {
                let winWidth = $(window).width()
                let scale = winWidth / 1024
                this.scale = scale
                this.width = 930 * scale
                this.originWidth = 930 * scale
                let originPositions = [
                    {
                        left: 74,
                        top: 77
                    },
                    {
                        left: 261,
                        top: 77
                    },
                    {
                        left: 394,
                        top: 77
                    },
                    {
                        left: 651,
                        top: 77
                    },
                    {
                        left: 74,
                        top: 198
                    },
                    {
                        left: 201,
                        top: 265
                    },
                    {
                        left: 451,
                        top: 202
                    },
                    {
                        left: 584,
                        top: 258
                    },
                    {
                        left: 71,
                        top: 452
                    },
                    {
                        left: 261,
                        top: 393
                    },
                    {
                        left: 387,
                        top: 452
                    },
                    {
                        left: 649,
                        top: 391
                    },
                    {
                        left: 74,
                        top: 585
                    },
                    {
                        left: 202,
                        top: 648
                    },
                    {
                        left: 456,
                        top: 589
                    },
                    {
                        left: 585,
                        top: 645
                    }
                ]
                this.originPositions = originPositions.map(a => {
                    return {
                        left: a.left * scale,
                        top: a.top * scale
                    }
                })
                let puzzle = this.puzzle
                if (puzzle && puzzle.length) {
                    for (let i = 0; i < puzzle.length; i++) {
                        if (puzzle[i] === 1) {
                            this.positions[i].filled = true
                        }
                    }
                    this.positions = this.positions.slice(0)
                }
                this.imgWidthList = this.imgWidthList.map(w => {
                    return w * scale
                })
            }, 0)
        },
        onTouchStart(event) {
            document.body.style.overflow = 'hidden'
            if (event.target.id) {
                if (this.dragDisable) {
                    return
                }
                this.fillIndex = -1
                this.minDt = Number.MAX_VALUE
                let element = event.targetTouches[0]
                let index = parseInt(event.target.id.split('-')[1])
                this.curDragIndex = index
                this.positions[index].x = element.clientX
                this.positions[index].y = element.clientY
                let pos = this.positions[index]
                event.target.style.cssText = `left: ${pos.left}px; top: ${pos.top}px;`
            }
        },

        init() {
            ;(function (doc, win) {
                var docEl = doc.documentElement,
                    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
                    recalc = function () {
                        var clientWidth = docEl.clientWidth
                        var clientHeight = docEl.clientHeight

                        if (!clientWidth) return
                        if (clientWidth < 1200) {
                            if (this.language === 'ja') {
                                docEl.style.fontSize = 14 * (clientWidth / 1080) + 'px'
                            } else {
                                docEl.style.fontSize = 16 * (clientWidth / 1080) + 'px'
                            }
                            if (clientWidth > 1023) {
                                if (this.language === 'ja') {
                                    docEl.style.fontSize = '16px'
                                } else {
                                    docEl.style.fontSize = '16px'
                                }
                            }
                        } else {
                            if (this.language === 'ja') {
                                docEl.style.fontSize = '16px'
                            } else {
                                docEl.style.fontSize = '18px'
                            }
                        }
                    }
                if (!doc.addEventListener) return
                win.addEventListener(resizeEvt, recalc, false)
                doc.addEventListener('DOMContentLoaded', recalc, false)
            })(document, window)
            // 禁止双指放大
            document.documentElement.addEventListener(
                'touchstart',
                function (event) {
                    if (event.touches.length > 1) {
                        event.preventDefault()
                    }
                },
                false
            )
            var lastTouchEnd = 0
            document.documentElement.addEventListener(
                'touchend',
                function (event) {
                    var now = Date.now()
                    if (now - lastTouchEnd <= 300) {
                        event.preventDefault()
                    }
                    lastTouchEnd = now
                },
                false
            )
            document.addEventListener('gesturestart', function (event) {
                event.preventDefault()
            })
        },
        onTouchMove(event) {
            if (!event.target.id) {
                return
            }
            if (this.dragDisable) {
                return
            }
            let element = event.targetTouches[0]
            let index = parseInt(event.target.id.split('-')[1])

            let x = element.clientX - this.positions[index].x
            let y = element.clientY - this.positions[index].y
            let pos = this.positions[index]

            element.target.style.cssText = `transform: translate(${x}px, ${y}px); left: ${pos.left}px; top:  ${pos.top}px;`
            for (let i = 0; i < this.originPositions.length; i++) {
                let targetOffset = $('#dragtarget-' + i).offset()
                let dragOffset = $(event.target).offset()
                let dt = Math.sqrt(Math.pow(dragOffset.left - targetOffset.left, 2) + Math.pow(dragOffset.top - targetOffset.top, 2))

                // console.log(
                //     `index: ${i}, (offsetLeft, offsetTop): (${targetOffset.left}, ${targetOffset.top}), (x, y): (${dragOffset.left}, ${dragOffset.top}), dt: ${dt}`
                // )
                if (dt < this.minDt) {
                    this.fillIndex = i
                    this.minDt = dt
                }
            }
        },
        onTouchEnd(event) {
            if (this.dragDisable) {
                return
            }
            document.body.style.overflow = 'auto'
            let targetIndex = parseInt(event.target.id.split('-')[1])
            let pos = this.positions[targetIndex]
            event.target.style.cssText = `transform: rotate(${pos.rotate}deg); left: ${pos.left}px; top:  ${pos.top}px;`
            if (this.fillIndex >= 0 && this.minDt < 20 && this.fillIndex === this.curDragIndex) {
                this.positions[this.fillIndex].filled = true
                if (this.action === 'create' && localStorage.getItem('testCreate')) {
                    for (let i = 0; i < 8; i++) {
                        this.positions[i].filled = true
                    }
                }
                if (this.action === 'join' && localStorage.getItem('testJoin')) {
                    this.positions.map(item => {
                        item.filled = true
                    })
                }
                let count = 0
                let curPuzzle = []
                for (let i = 0; i < 16; i++) {
                    curPuzzle.push(0)
                }
                for (let i = 0; i < this.positions.length; i++) {
                    if (this.positions[i].filled) {
                        curPuzzle[i] = 1
                        count++
                    }
                    if (this.action === 'create') {
                        if (count >= 8) {
                            this.dragDisable = true
                            this.$emit('create', curPuzzle)
                            break
                        }
                    }
                    if (this.action === 'join') {
                        if (count >= 16) {
                            this.dragDisable = true
                            this.$emit('join')
                            break
                        }
                    }
                }
            }
        },
        handleShare(data) {
            let uuid = this.shareUUID || ''
            let myPuzzleURL = 'https://h5-archero.habby.com/halloween/index.html?uuid=' + uuid

            if (window.location.host.indexOf('test') > -1) {
                myPuzzleURL = 'https://test-h5-archero.habby.com/halloween/index.html?uuid=' + uuid
            }

            if (location.hostname.match(/[0-9]+\.[0-9]+\.[0-9]+\.[0-9]+/)) {
                myPuzzleURL = 'https://test-h5-archero.habby.com/halloween/index.html?uuid=' + uuid
            }
            if (data == 'facebook') {
                let facebookShareURL = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(myPuzzleURL)
                window.location.href = facebookShareURL
            } else if (data == 'twitter') {
                let twitterShareURL = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(myPuzzleURL)
                window.location.href = twitterShareURL
            } else {
                this.urlShare = myPuzzleURL
                this.copy()
            }
        },
        copy() {
            if (this.infoShow) {
                return
            }
            const input = document.getElementById('input')
            input.value = this.urlShare
            console.log('copy', input.value)
            // 聚焦
            input.focus()
            // 选择需要复制的文本
            if (input.setSelectionRange) {
                input.setSelectionRange(0, input.value.length)
            } else {
                input.select()
            }

            try {
                const result = document.execCommand('copy')
                this.tooltipMsg = this.lang[0][27] || '分享链接复制成功'
                this.infoShow = true
            } catch (e) {
                console.error('复制失败，请重试~')
            }
            input.blur()
            document.activeElement.blur()
        }
    },
    watch: {
        items(puzzle, oldPuzzle) {
            if (puzzle && puzzle.length) {
                for (let i = 0; i < puzzle.length; i++) {
                    if (puzzle[i] === 1) {
                        this.positions[i].filled = true
                    }
                }
                this.positions = this.positions.slice(0)
            }
        },
        puzzle(newValue, old) {
            if (newValue !== old) {
                let puzzle = this.puzzle
                if (puzzle && puzzle.length) {
                    for (let i = 0; i < puzzle.length; i++) {
                        if (puzzle[i] === 1) {
                            this.positions[i].filled = true
                        }
                    }
                    this.positions = this.positions.slice(0)
                }
            }
        },
        infoShow(newValue, oldValue) {
            if (newValue) {
                let timeoutId = setTimeout(
                    function () {
                        this.infoShow = false
                        clearTimeout(timeoutId)
                    }.bind(this),
                    2000
                )
            }
        }
    }
}
</script>

<style lang="less" scoped>
.drag-root {
    width: 100%;
}

.drag-list {
    margin: 0 auto !important;
}

.drag-list-wrap {
    width: 100%;
    height: 100%;
    position: relative;
    background: url('../assets/images/puzzle_bg.png') 100% 100% no-repeat;
    background-size: 100% 100%;
}

.dragtarget {
    position: absolute;
}

.dragtarget-img-hide {
    opacity: 0;
}

.dragtarget-img-show {
    opacity: 1;
}

.cur-drag-container {
    position: relative;
    // transform: translateY(-4rem);
    // width: 57.25rem;
    height: 33.875rem;
    background: rgba(0, 0, 0, 0.42);
    border-radius: 2.25rem;
    border: 2px solid #000000;
    div {
        position: absolute;
    }
}

.cur-drag-box {
    position: absolute;
}

.shareWrap {
    // height: 7.875rem;
    // width: 44.625rem;
    padding: 0 10.125rem;
    // transform: translateY(-4rem);
    font-size: 2.625rem;
    color: #fff;
    p {
        height: 1.875rem;
    }
    .share {
        height: 8.5rem;
        text-align: left;
        padding: 0 3.625rem;
        border-radius: 4.25rem;
        border: 0.25rem solid #ffffff;
        display: flex;
        div {
            display: flex;
            justify-content: space-around;
            flex-direction: column;
            align-items: center;
            word-break: break-all;
        }
        span {
            height: 8.5rem;
            display: inline-block;
            margin-right: 1rem;
            img {
                width: 4.5rem;
                margin-top: 2rem;
            }
        }
    }
}

.tooltip {
    width: 100%;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    text-align: center;
    .tooltiptext {
        max-width: 60%;
        background: rgba(0, 0, 0, 0.3);
        display: inline-block;
        padding: 3.25rem;
        border-radius: 2.625rem;
        color: #ffffff;
        font-size: 2.2rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/text.vue